/* unplugin-vue-components disabled */import { render } from "./orderRefund.vue?vue&type=template&id=0f1efe50&scoped=true"
import script from "./orderRefund.vue?vue&type=script&lang=js"
export * from "./orderRefund.vue?vue&type=script&lang=js"

import "./orderRefund.vue?vue&type=style&index=0&id=0f1efe50&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f1efe50"]])

export default __exports__